// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div#app-container .sidebar-container[data-v-2efa88e0] {\n  top: 48px;\n}", ""]);
// Exports
module.exports = exports;
